import PropTypes from "prop-types"
import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import TabNavigation from "components/tablink/tablink"

class EmailSettingMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    render() {
        const navItems = [
            {
                id: 'all',
                label: 'All',
                link: `/setting/email-templates/all`
            },
            {
                id: 'signature',
                label: 'Email Signature',
                link: `/setting/email-templates/signature`
            },
            {
                id: 'social-media',
                label: 'Social Media Link',
                link: `/setting/email-templates/social-media`
            }
        ];
        return (
            <React.Fragment>
                <TabNavigation navItems={navItems}

                />
            </React.Fragment>
        )
    }
}
EmailSettingMenu.propTypes = {
    match: PropTypes.object
}
export default withRouter(EmailSettingMenu)
